import { render, staticRenderFns } from "./ManualSamlAuth.vue?vue&type=template&id=154becc4&scoped=true&"
import script from "./ManualSamlAuth.vue?vue&type=script&lang=js&"
export * from "./ManualSamlAuth.vue?vue&type=script&lang=js&"
import style0 from "./ManualSamlAuth.vue?vue&type=style&index=0&id=154becc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154becc4",
  null
  
)

export default component.exports